import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright 2022 The Parca Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import { Select, useParcaContext, useURLState } from '@parca/components';
import { useUIFeatureFlag } from '@parca/hooks';
const ViewSelector = ({ defaultValue, navigateTo, position, placeholderText, primary = false, addView = false, disabled = false, icon, id, }) => {
    const [callgraphEnabled] = useUIFeatureFlag('callgraph');
    const [dashboardItems = ['icicle'], setDashboardItems] = useURLState({
        param: 'dashboard_items',
        navigateTo,
    });
    const { enableSourcesView } = useParcaContext();
    const allItems = [
        { key: 'table', canBeSelected: !dashboardItems.includes('table') },
        { key: 'icicle', canBeSelected: !dashboardItems.includes('icicle') },
    ];
    if (enableSourcesView === true) {
        allItems.push({ key: 'source', canBeSelected: false });
    }
    if (callgraphEnabled) {
        allItems.push({
            key: 'callgraph',
            canBeSelected: !dashboardItems.includes('callgraph'),
        });
    }
    const getOption = ({ key, supportingText, }) => {
        const capitalizeFirstLetter = (string) => {
            return `${string.charAt(0).toUpperCase()}${string.slice(1)}`;
        };
        const title = capitalizeFirstLetter(key);
        return {
            active: _jsx(_Fragment, { children: title }),
            expanded: (_jsxs(_Fragment, { children: [_jsx("span", { children: title }), supportingText !== null && _jsx("span", { className: "text-xs", children: supportingText })] })),
        };
    };
    const items = allItems.map(item => ({
        key: item.key,
        disabled: !item.canBeSelected,
        element: getOption(item),
    }));
    const onSelection = (value) => {
        if (addView) {
            setDashboardItems([dashboardItems[0], value]);
            return;
        }
        const isOnlyChart = dashboardItems.length === 1;
        if (isOnlyChart) {
            setDashboardItems([value]);
            return;
        }
        // Note: this will need to be updated if we ever have more more than 2 panels
        const isFirstChart = position === 0;
        const newDashboardItems = isFirstChart
            ? [value, dashboardItems[1]]
            : [dashboardItems[0], value];
        setDashboardItems(newDashboardItems);
    };
    return (_jsx(Select, { className: "h-view-selector", items: items, selectedKey: defaultValue, onSelection: onSelection, placeholder: placeholderText ?? 'Select view type...', primary: primary, disabled: disabled, icon: icon, id: id }));
};
export default ViewSelector;
